<template>
  <div class="es-page-box">
    <el-pagination background
                   small
                   layout="total, prev, pager, next, jumper"
                   :page-size="data.pageSize"
                   :current-page="data.pageNum"
                   :total="data.total"
                   @current-change="checkChange">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'esPagination',
  props: {
    data: {
      required: true
    }
  },
  methods: {
    checkChange (cpage) {
      this.$emit('change', cpage)
    }
  }
}
</script>

<style scoped>
</style>